<div class="assign-search-dropdown">
  <div class="assign-search-dropdown__search">
    <form [formGroup]="formGroup">
      <div class="search" (click)="searchInput.focus()">
        <svg-icon class="search-icon" src="/assets/img/search-icon.svg" />
        <input
          #searchInput
          type="text"
          formControlName="search"
          [placeholder]="'List.Filters.search' | translate"
          (input)="searchEmployee()"
        />

        @if (formGroup.get('search')?.value) {
          <svg-icon class="clear-icon" [src]="'/assets/img/close-icon.svg'" (click)="clearSearch()" />
        }
      </div>
    </form>
  </div>
  <div class="assign-search-dropdown__list">
    @if (loading) {
      <div class="assign-search-dropdown__list__loader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </div>
    }

    @if (assignSearchDropdown?.employees.length) {
      <ng-container>
        <h5 class="assign-search-dropdown__list__title">
          {{ 'Projects.team' | translate }}
        </h5>

        <div
          class="assign-search-dropdown__list__item"
          [class.assign-search-dropdown__list__item--selected]="isEmployeeAssigned(employee)"
          *ngFor="let employee of assignSearchDropdown.employees"
          (click)="$event.stopPropagation(); toggleEmployeeAssignment(employee)"
        >
          <avatar [imageUrl]="imageUrl(employee?.userPerson?.photo)"></avatar>
          <div class="ml-2">
            <h5 class="assign-search-dropdown__list__item__name">
              <span class="pii">{{ employee?.userPerson?.previewName || employee?.userPerson?.fullName || employee?.userPerson?.email }}</span>
            </h5>
            @if (employee?.role) {
              <span class="assign-search-dropdown__list__item__position">
                {{ 'ROLES.' + employee.role | translate }}
              </span>
            }
          </div>
        </div>
      </ng-container>
    }

    @if (assignSearchDropdown?.contacts.length && assignSearchDropdown?.employees.length) {
      <hr />
    }

    <ng-container *ngIf="assignSearchDropdown?.contacts.length">
      <h5 class="assign-search-dropdown__list__title">
        {{ 'Projects.contacts' | translate }}
      </h5>

      <div
        class="assign-search-dropdown__list__item"
        [class.assign-search-dropdown__list__item--selected]="isContactAssigned(contact)"
        *ngFor="let contact of assignSearchDropdown.contacts"
        (click)="$event.stopPropagation(); toggleContactAssignment(contact)"
      >
        <avatar />
        <div class="ml-2">
          <h5 class="assign-search-dropdown__list__item__name">
            <span class="pii">{{ contact?.fullName || contact?.email }}</span>
          </h5>
          @if (contact.employee?.role) {
            <span class="assign-search-dropdown__list__item__position">
              {{ 'ROLES.' + contact.employee.role | translate }}
            </span>
          }
        </div>
      </div>
    </ng-container>
  </div>
</div>
